import React from 'react';

import { ListPanelWrapper } from '@eika/link-panel';

import NoAccountsCards from '../../../../components/AccountList/NoAccountsCards';

export function NoAccountsView() {
    return (
        <ListPanelWrapper
            className="sgw-content account-overview"
            data-testid="account-overview-list"
            contentWrapperAs="ol"
        >
            <NoAccountsCards className="no-accounts__wrapper" />
        </ListPanelWrapper>
    );
}
